$(document).ready(function(){

  $('.product-thumbnail').click(function(e){
    var index = $(this).data('loop');

    $('.product-list-item-image').removeClass('active');
    $('.product-thumbnail').removeClass('active');

    $(this).addClass('active');
    $('.product-list-item-image[data-loop="' + index +'"]').addClass('active');
  });


  // $(".video-top").click(function(){
  //   document.querySelectorAll('.video-top').forEach(vid => vid.pause());
  //   $(this).get[0].play(); 
  //   console.log("successes!!!!");
  // });

 

  //   $("#player").click(function(){
  //     video.pause();
  //    console.log("successes!!!!");
  //   });


  
})

 // var video = document.getElementById("player");
 // var videoall = document.getElementsByClassName("video-top");


